<admin-app-header></admin-app-header>

<div class="videoWrapper">
    <video #qrCodeElem></video>
</div>
